/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
                //modification to the way bootstrap dropdowns work. this makes them work on hover at normal rez and on click/touch on phone/tablet
                var $win = $(window);
                $win.resize(function () {
                    if ($win.width() > 768) {
                        $(".navbar-nav > .dropdown > a").attr("data-toggle", "");
                    }
                    else {
                        $(".navbar-nav > .dropdown > a").attr("data-toggle", "dropdown");
                    }
                }).resize();
                $(".dropdown-menu").find("input, button").each(function () {
                    $(this).click(function (e) {
                        e.stopPropagation();
                    });
                });
                // Bootstrap Tooltips
                $(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                });
                function focusTimeout() {
                    setTimeout(function () {
                        $('input[type="search"]').focus();
                    }, 400);
                }

                var searchForm = $('.nav-search-form');
                $('.nav-search').on('click', function () {
                    $(this).toggleClass('n-open');
                    focusTimeout();
                    searchForm.toggleClass('vshow');
                });
                // Prevent jump on empty nav click
                $(".navbar-nav a[href^='#']").on('click', function (e) {
                    e.preventDefault();
                });

                $('.shiftnav-sub- > a').on('click', function () {
                    $(this).parent().toggleClass('open');
                });
                if ($(".shiftnav-sub- > li").hasClass("active")) {
                    $(this).parent().addClass('open');
                }

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
              $('.h-client-carousel').slick({
                slidesToShow: 6,
                slidesToScroll: 4,
                arrows: true,
                fade: true,
              });
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'category': {
            init: function () {
                // JavaScript to be fired on the about us page
                $('.article-tabs').waypoint('sticky');
                $(".category a[href^='#']").on('click', function (e) {
                    e.preventDefault();
                    var hash = this.hash;
                    $('body, html').animate({
                        scrollTop: $(hash).offset().top - 128
                    }, 300, function () {
                        if (history.pushState) {
                            history.pushState(null, null, hash);
                        }
                        else {
                            location.hash = hash;
                        }
                    });
                });
                $('body').scrollspy({
                    target: '.sticky-wrapper',
                    offset: 130
                });
                $('[data-spy="scroll"]').each(function () {
                    var $spy = $(this).scrollspy('refresh');
                });
                $('.main').waypoint({
                    handler: function (down) {
                        $('.stuck').each(function () {
                            $(this).toggleClass('unstuck');
                        });
                    },
                    offset: function () {
                        var articleTabs = $(this).find('.article-tabs').outerHeight();
                        return -$(this).outerHeight() + articleTabs + 50;
                    }
                });
                function fixedTabs() {
                    var tabs = $('.article-tabs');
                    var coo1 = $('.scale-articles')[0].getBoundingClientRect().left;
                    var tabWidth = $('.scale-articles').outerWidth();
                    tabs.css({
                        left: coo1,
                        width: tabWidth
                    });
                }

                fixedTabs();
                $(window).resize(fixedTabs);
            }
        },
        'search': {
            init: function () {
                // JavaScript to be fired on the search page
                //    $('.nav-search').addClass('n-open');
                //    $('.nav-search-form').addClass('vshow n-sp');
            }
        },
        'single_scale': {
            init: function () {
                // JavaScript to be fired on the Scale Product page
                $('body').scrollspy({
                    target: '.sticky-wrapper',
                    offset: 130
                });
                $('[data-spy="scroll"]').each(function () {
                    var $spy = $(this).scrollspy('refresh');
                });
                // Initialize Product Gallery Slider
                $('.slider-for').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '.slider-nav'
                });
                $('.slider-nav').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    asNavFor: '.slider-for',
                    dots: false,
                    focusOnSelect: true,
                    variableWidth: false,
                    infinite: false
                });
              function fixedPositioning() {
                var above = $('.above-slider'),
                  coo = $('.slick-slider')[0].getBoundingClientRect().left,
                  aboveHeight = above.outerHeight(),
                  buyWidth = $('.slick-slider').outerWidth();

                var tabs = $('.p-tabs'),
                  coo1 = $('.p-tab-wrap')[0].getBoundingClientRect().left,
                  tabWidth = $('.p-tab-wrap').outerWidth();

                tabs.css({
                  left: coo1 + 1,
                  width: tabWidth - 1,
                  top: aboveHeight
                });

                if(above.hasClass('stuck-full')) {
                  above.css({
                    left: coo + 1,
                    // height: aboveHeight,
                    width: tabWidth - 2
                  });
                } else {
                  above.css({
                    left: coo,
                    // height: aboveHeight,
                    width: buyWidth
                  });
                }
                console.log('Slider with is ' + buyWidth + '\nTab width is ' + tabWidth);
              }
                // Waypoints
                // return -$(this).outerHeight() + $(this).find('.sticky-wrapper').outerHeight() + 50;
                $('.p-tabs').waypoint('sticky', {
                    handler: function () {
                        $('.above-slider').toggleClass('stuck-full');
                        fixedPositioning();
                    },
                    offset: function () {
                        var config = $('.above-slider').outerHeight();
                        console.log(config);
                        return config;
                    }
                });
                $('.main').waypoint({
                    handler: function (down) {
                        $('.stuck').each(function () {
                            $(this).toggleClass('unstuck');
                        });
                    },
                    offset: function () {
                        var above = $(this).find('.above-slider').outerHeight(),
                            tabs = $(this).find('.p-tabs').outerHeight();
                        return -$(this).outerHeight() + (above + tabs);
                    }
                });

                fixedPositioning();
                $(window).resize(fixedPositioning);
                $('.above-slider').waypoint('sticky');
                $(".scale a[href^='#']").on('click', function (e) {

                    // prevent default anchor click behavior
                    e.preventDefault();
                    // store hash
                    var hash = this.hash;
                    // animate
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top - 128
                    }, 300, function () {

                        // when done, add hash to url
                        // (default click behaviour)
                    });
                    window.location.hash = hash;
                });
                // iLightbox
                $('.ilightbox').iLightBox({
                    skin: 'dark'
                });
            }
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

